//Custom lazyload
//Version 3.7 for ECMAScript 6 & jQuery >= 1.12

let $window = $(window);

function getCoords($item) {
    // console.log('getCoords', $item);
    let top = $item.offset().top;
    let left = $item.offset().left;
    let height = $item.height();
    let width = $item.width();
    let bottom = top + height;
    let right = left + width;
    return {top: top, left: left, right: right, bottom: bottom};
}

function valueBetween(value, min, max) {
    return value >= min && value <= max;
}

function visibleInElement($item, coordElement, marginView) {
    if (!marginView) {
        marginView = 0;
    }
    let small = getCoords($item);
    let big = coordElement;
    if (!big['top']) {
        big['top'] = $window.scrollTop() - marginView;
    }
    if (!big['left']) {
        big['left'] = 0;
    }
    if (!big['right']) {
        big['right'] = $window.width();
    }
    if (!big['bottom']) {
        big['bottom'] = $window.scrollTop() + $window.height() + marginView;
    }

    let visibleTop = valueBetween(small.top, big.top, big.bottom) || valueBetween(small.bottom, big.top, big.bottom) || (small.top < big.top && small.bottom > big.bottom);
    let visibleLeft = valueBetween(small.left, big.left, big.right) || valueBetween(small.right, big.left, big.right) || (small.left < big.left && small.right > big.right);

    // if ($item.data('logme') || $item.parents(".logme").length) {
    //     console.log('visibleInElement', small, big, visibleTop, visibleLeft);
    // }
    // console.log('visibleInElement', small, big, visibleTop, visibleLeft);

    return visibleTop && visibleLeft;
}

function fullyVisibleInElement($item, coordElement, marginView) {
    if (!marginView) {
        marginView = 0;
    }
    let ret = false;
    let small = getCoords($item);
    let big = coordElement;
    if (!big['top']) {
        big['top'] = $window.scrollTop() - marginView;
    }
    if (!big['left']) {
        big['left'] = 0;
    }
    if (!big['right']) {
        big['right'] = $window.width();
    }
    if (!big['bottom']) {
        big['bottom'] = $window.scrollTop() + $window.height() + marginView;
    }

    if (visibleInElement($item, big, marginView)) {
        let fullX = valueBetween(small.top, big.top, big.bottom) && valueBetween(small.bottom, big.top, big.bottom);
        let fullY = valueBetween(small.left, big.left, big.right) && valueBetween(small.right, big.left, big.right);
        // console.log("fullyVisibleInElement", fullX, fullY);
        return fullX && fullY;
    }
    return ret;
}

function lazyload(debugmode) {
    //window position item
    let windowPosition = {top: $(window).scrollTop(), bottom: $(window).scrollTop() + $(window).height()};

    //lazyload selector
    let lazySelector = ".lazy:not(.loaded), [data-lazy-src]:not(.loaded), [data-lazy-style]:not(.loaded), .lazy-container";

    //checkvisible selector
    let checkVisibleSelector = ".check-visible";

    //margin outer for lazyload, in px
    let marginOuter = 20;


    function lazyLoad(item) {
        if (item.hasClass("lazy-container")) {
            item.find(lazySelector).each(function () {
                lazyLoad($(this));
            });
        } else {
            if (!debugmode) {
                console.log("lazyload");
            }
            item.addClass("loaded");
            if (item.attr("data-lazy-src")) {
                item.attr("src", item.attr("data-lazy-src"));
                item.attr("data-lazy-src", null);
            }
            if (item.attr("data-lazy-srcset")) {
                item.attr("srcset", item.attr("data-lazy-srcset"));
                item.attr("data-lazy-srcset", null);
            }
            if (item.attr("data-lazy-style")) {
                item.attr("style", item.attr("data-lazy-style"));
                item.attr("data-lazy-style", null);
            }
        }
    }

    function checkVisible(item, topToCheck, bottomToCheck) {
        let visible = visibleInElement(item, {top: topToCheck, bottom: bottomToCheck});
        if (visible) {
            item.addClass("cv-visible");
            item.trigger("item-visible");
            if (item.hasClass("cv-invisible")) {
                item.removeClass("cv-invisible");
                item.trigger("item-visible-switch");
            }
        } else {
            item.addClass("cv-invisible");
            item.trigger("item-invisible");
            if (item.hasClass("cv-visible")) {
                item.removeClass("cv-visible");
                item.trigger("item-invisible-switch");
            }
        }
    }

    $(document).ready(function () {
        initialLoad();
    });

    function debugLog(message, $image) {
        let top = $image.offset().top;
        let bottom = top + $image.height();
        let srcDisp = "";

        let src = $(this).attr("src");
        if (src) {
            console.log(src);
            let split = src.split("/");
            srcDisp = split[split.length - 1]
        }

        let image = {
            "top": top,
            "bottom": bottom,
            "src": srcDisp,
        };
        let wi = {
            "top": windowPosition.top - marginOuter,
            "bottom": windowPosition.bottom + marginOuter,
        };

        console.log(message, image, wi);
    }

    function initialLoad() {
        let bottomToCheck = windowPosition.bottom + marginOuter;
        let topToCheck = windowPosition.top - marginOuter;
        // console.log(topToCheck, bottomToCheck);

        $(lazySelector).each(function () {
            let visible = visibleInElement($(this), {});
            if (visible) {
                $(this).trigger("lazyload");
                if (debugmode) {
                    debugLog("lazyload initial", $(this));
                }
            }
        });

        $(checkVisibleSelector).each(function () {
            checkVisible($(this), topToCheck, bottomToCheck);
        });
    }

    $(lazySelector).on("lazyload", function () {
        lazyLoad($(this));
    });

    function scrollUp(sight) {
        $(lazySelector).each(function () {
            let visible = visibleInElement($(this), {top: sight});
            if (visible) {
                $(this).trigger("lazyload");
                if (debugmode) {
                    debugLog("lazyload scroll up", $(this));
                }
            }
        });
    }

    function scrollDown(sight) {
        $(lazySelector).each(function () {
            let visible = visibleInElement($(this), {bottom: sight});
            if (visible) {
                $(this).trigger("lazyload");
                if (debugmode) {
                    debugLog("lazyload scroll down", $(this));
                }
            }
        });
    }

    $(checkVisibleSelector).on("check-visible", function () {
        let bottomToCheck = windowPosition.bottom + marginOuter;
        let topToCheck = windowPosition.top - marginOuter;
        checkVisible($(this), topToCheck, bottomToCheck);
    });

    //window triggers
    $(window).on("scroll resize manualLazyload", function () {
        //triggers on scroll & resize, updates windowPosition. Adds triggers with scroll direction
        let currentTop = $(window).scrollTop();
        let currentBottom = currentTop + $(window).height();
        if (currentTop < windowPosition.top) {
            $(window).trigger("scrollUp", currentTop - marginOuter);
        }
        if (currentTop > windowPosition.top) {
            $(window).trigger("scrollDown", currentBottom + marginOuter);
        }
        windowPosition = {top: currentTop, bottom: currentBottom};
        $(checkVisibleSelector).trigger("check-visible", currentTop, currentBottom);
        // console.log(windowPosition);
    }).on("scrollDown", function (e, sight) {
        // console.log("scroll Down");
        scrollDown(sight);

    }).on("scrollUp", function (e, sight) {
        // console.log("scroll Up");
        scrollUp(sight);

    }).on("inititialLoad", function () {
        initialLoad();
    });

}

export {
    lazyload, getCoords, visibleInElement, fullyVisibleInElement,
}


// WEBPACK FOOTER //
// ./scripts/util/lazyload.js